import { forEachObjIndexed, prop, propOr, propEq, isEmpty, find } from 'ramda'
import errorMessages from '@/modules/error-messages'

export default (error, initialMsg = '') => {
  if (error && !isEmpty(error)) {
    let msg = initialMsg
    if (error.$dirty && error.$invalid) {
      const generateErrorMsg = param => {
        if (!error[param.type]) {
          const messageObject = find(propEq('type', prop('type', param)), errorMessages)
          msg = propOr('Error', 'message', messageObject)
        }
      }
      forEachObjIndexed(generateErrorMsg, error.$params)
    }
    return msg
  }
}



// WEBPACK FOOTER //
// ./src/utils/generateErrorMsg.js